import {
  AuthContainer,
  AuthContent,
  AuthHeader,
} from '@affine/component/auth-components';
import { OAuth } from '@affine/core/components/affine/auth/oauth';
import { AuthService } from '@affine/core/modules/cloud';
import type { AuthSessionStatus } from '@affine/core/modules/cloud/entities/session';
import { useI18n } from '@affine/i18n';
import { useLiveData, useService } from '@toeverything/infra';
import { useEffect } from 'react';

// PIPE fork: authentication is Keycloak OIDC only — a single "Continue with OIDC" action. The AFFiNE
// email/password path, the "add another self-hosted server" footer link, the no-op Back button (it
// only reset to the current step), and the upstream self-host version guard (our fork pins a matching
// contract version, so it never fired) are all removed.
export const SignInStep = ({
  onAuthenticated,
}: {
  onAuthenticated?: (status: AuthSessionStatus) => void;
}) => {
  const t = useI18n();
  const authService = useService(AuthService);
  const loginStatus = useLiveData(authService.session.status$);

  useEffect(() => {
    onAuthenticated?.(loginStatus);
  }, [loginStatus, onAuthenticated]);

  return (
    <AuthContainer>
      <AuthHeader title={t['com.affine.auth.sign.in']()} />
      <AuthContent>
        {/* PIPE: on web this starts OIDC server-side (`/api/oauth/login`), which accepts no
            caller redirect_uri (open-redirect defense) — so no redirect target flows here. */}
        <OAuth />
      </AuthContent>
    </AuthContainer>
  );
};
